import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { Observable } from 'rxjs';
import { OverrideStatusEnum } from '../../../constants/override-status.enum';
import { Router } from '@angular/router';
import { IUserProfileDataModel } from '../../../entities-api/IUserProfileDataModel';
import { IDictionaryItemModel } from '../../../entities-api/IDictionaryItemModel';
import { IGlobalEmployeeDictionariesModel } from '../../../entities-api/IGlobalEmployeeDictionariesModel';
import { forkJoin, from } from 'rxjs';
@Component({
  selector: 'opm-edit-profile',
  templateUrl: './opm-edit-profile.component.html',
  styleUrls: ['./opm-edit-profile.component.less'],
  standalone: false
})
export class OpmEditProfileComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router
  ) { }

  profile: IUserProfileDataModel = <IUserProfileDataModel>{ Origin: {}, Override: {}, Errors: [] };
  dictionaries: IGlobalEmployeeDictionariesModel = <IGlobalEmployeeDictionariesModel>{};
  visiblMessagePopup: boolean = false;
  dataLoaded: boolean = false;
  overrideStatusEnum = OverrideStatusEnum;
  selectedStatus = <IDictionaryItemModel>{};
  selectedOffice = <IDictionaryItemModel>{};
  selectedCountry = <IDictionaryItemModel>{};
  selectedOrganization = <IDictionaryItemModel>{};
  errorMessage: string;
  visiblErrorPopup: boolean = false;
  userId: string;
  emailPattern: string = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";
  strnumspacePattern: string = "^[a-zA-Z0-9 ]*$";
  strnumsPattern: string = "^[a-zA-Z0-9]*$";
  strAllPattern: string = "^[a-zA-Z0-9]+[^]*$";
  readOnlyAccessData: boolean = false;
  readWriteAccessData: boolean = false;
  ngOnInit() {
    window.scrollTo(0, 0);

    this.activatedRoute.params.subscribe((params: Params) => {
      this.userId = params['userId'];

      var dictionariesPromise = this.userService.getDictionaries();
      var getUserProfilePromise = this.userService.getUserProfile(this.userId);

      forkJoin([from(dictionariesPromise), from(getUserProfilePromise)])
        .toPromise().then((data: any) => {
          this.dictionaries = data[0];
          this.profile = data[1];

          this.profile.Override.Comment = null;
          this.profile.Override.TicketNumber = null;

          this.setDefaultValues();
          this.dataLoaded = true;
        }).catch(err => {
          this.router.navigate(["/"]);
          return;
        });
    });
    this.userService.getReadOnlyAccessData().then((response) => {
      this.readOnlyAccessData = response;
    })
    this.userService.getWriteAccessData().then((response) => {
      this.readWriteAccessData = response;
    })
  }

  revert(id: string): void {
    if (this.readWriteAccessData == true) {
      this.userService.revertOverride(id).then(() => {
        this.visiblMessagePopup = false;
        this.refreshUsersAndRedirect();
      },
        this.handleError);
    }
  }

  save() {
    if (this.readWriteAccessData == true) {
      this.profile.Override.PreferredFullName = `${this.profile.Override.LastName}, ${this.profile.Override.FirstName}`;

      this.userService.create(<any>this.profile.Override).then(() => {
        this.refreshUsersAndRedirect();
      },
        this.handleError);
    }
  }

  private handleError = (response) => {
    this.visiblMessagePopup = false;
    this.visiblErrorPopup = true;
    this.errorMessage = response.error.Message;
  }

  private refreshUsersAndRedirect() {
    this.userService.getUsers().then(() => {
      this.router.navigateByUrl("");
    });
  }

  fillDescription(destinationFildName: string, sourceFieldName: string, items: IDictionaryItemModel[]) {
    var filteredItems: IDictionaryItemModel[] = items.filter(item => {
      return item.Code === this.profile.Override[sourceFieldName];
    });

    if (filteredItems.length > 0) {
      this.profile.Override[destinationFildName] = filteredItems[0].Description;
    } else {
      this.profile.Override[destinationFildName] = null;
      this.profile.Override[sourceFieldName] = null;
    }
  }

  changeStatus(): void {
    this.profile.Override.EmployeeStatusDesc = this.selectedStatus.Description;
    this.profile.Override.EmployeeStatusCode = this.selectedStatus.Code;
  }

  changeCountry(): void {
    this.profile.Override.CountryDesc = this.selectedCountry.Description;
    this.profile.Override.CountryCode = this.selectedCountry.Code;
  }

  changeOffice(): void {
    this.profile.Override.OfficeDesc = this.selectedOffice.Description;
    this.profile.Override.OfficeCode = this.selectedOffice.Code;
  }

  changeOrganization(): void {
    this.profile.Override.OrganizationDesc = this.selectedOrganization.Description;
    this.profile.Override.OrganizationCode = this.selectedOrganization.Code;
  }

  parseBoolean(value: any): boolean {
    return value === true || value === 'true';
  }

  setDefaultValues(): void {
    this.selectedStatus = this.dictionaries.Statuses.filter((status) => {
      return status.Code === this.profile.Override.EmployeeStatusCode
        && status.Description === this.profile.Override.EmployeeStatusDesc;
    })[0];

    this.selectedCountry = this.dictionaries.Countries.filter((country) => {
      return country.Code === this.profile.Override.CountryCode
        && country.Description === this.profile.Override.CountryDesc;
    })[0];

    this.selectedOffice = this.dictionaries.Offices.filter((office) => {
      return office.Code === this.profile.Override.OfficeCode
        && office.Description === this.profile.Override.OfficeDesc;
    })[0];

    this.selectedOrganization = this.dictionaries.Organizations.filter((organization) => {
      return organization.Code === this.profile.Override.OrganizationCode
        && organization.Description === this.profile.Override.OrganizationDesc;
    })[0];

    this.profile.Override.MemberFirmCode = this.profile.Override.MemberFirmCode.toLocaleUpperCase();
    this.dictionaries.MemberFirms = this.dictionaries.MemberFirms.map((memberFirm) => memberFirm.toLocaleUpperCase());
  }
}
